import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,  setUser]  = useState(null);
  const [token, setToken] = useState(null);

  // Restore session from localStorage on refresh
  useEffect(() => {
    const t = localStorage.getItem('ar_token');
    const u = localStorage.getItem('ar_user');
    if (t && u) {
      setToken(t);
      setUser(JSON.parse(u));
    }
  }, []);

  function signIn(userData, jwt) {
    localStorage.setItem('ar_token', jwt);
    localStorage.setItem('ar_user',  JSON.stringify(userData));
    setToken(jwt);
    setUser(userData);
  }

  function signOut() {
    localStorage.removeItem('ar_token');
    localStorage.removeItem('ar_user');
    localStorage.removeItem('ar_active_vehicle');
    setToken(null);
    setUser(null);
  }

  const isAdmin = !!user?.isAdmin;

  return (
    <AuthContext.Provider value={{ user, token, signIn, signOut, isAuthenticated: !!token, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
